module.exports = __webpack_public_path__ + "img/border.834e4c46.png";